import { z } from 'zod';

import { certificateRoleEnum } from '~/modules/clients/common';
import { zodFeaturesSchema } from '~/modules/clients/companyAccounts/utils';

import { EmailSchema } from '@vestigas/utils';

/**
 * `CompanyAccountData` in the OpenAPI spec (`additionalProperties: true` — the
 * backend allows further keys we don't model here).
 */
const zodCompanyAccountDataSchema = z.object({
  accRefCompanyAccountMapping: z.boolean().nullish(),
  defaultPermissions: z.array(z.string()).nullish(),
  defaultSignatureRole: z.union([z.literal(''), certificateRoleEnum]).nullish(),
  featureFlags: z.object(zodFeaturesSchema).nullish(),
  supportEmail: z.union([EmailSchema, z.literal('')]).nullish(),
  supportPhoneNumber: z.string().nullish(),
});

/**
 * `CompanyAccount` in the OpenAPI spec. `companies` (required there, an array
 * of the full `CompanyAppResponse` shape) is intentionally not modeled: no
 * consumer of this endpoint reads it, and that ~15-field shape is already
 * modeled in `company/useQueryCompanyFromAliasAddress/validations.ts`
 * (`zodCompanyFromAliasAddressResponseSchema`). Duplicating it here for an
 * unused field isn't worth it — model it (reusing that schema, or hoisting it
 * to a shared location) if a consumer appears.
 */
export const zodCompanyAccountSchema = z.object({
  baseOuId: z.uuid().nullish(),
  data: zodCompanyAccountDataSchema.nullish(),
  id: z.uuid(),
  name: z.string(),
  // A plain int on purpose: the backend does not constrain the stored value,
  // so an off-scale one must stay readable and fixable through the update.
  strategicMultiplier: z.int(),
});

export const zodCompanyAccountResponseSchema = zodCompanyAccountSchema;
